module.exports = require("sharp");